import Ajax from "base/Ajax";

class GalleryItem {

    constructor(gallery, data = null) {
        this.gallery = gallery;
        this.data = data;
        this.changed = false;
    }

    /**
     * @param {Gallery} gallery
     * @param item
     * @return {GalleryItem}
     */
    static process_item(gallery, item) {
        require("gallery/video/GalleryItemVideo");
        require("gallery/image/GalleryItemImage");
        switch (item.type.id) {
            case '1': /*Video*/
                return new (require("gallery/video/GalleryItemVideo").default)(gallery, item);
                break;
            case '2': /*Image*/
                return new (require("gallery/image/GalleryItemImage").default)(gallery, item);
                break;
        }
    }

    getElementClasses() {
        return '';
    }

    save() {
        return this.changed ? Ajax.post(null, this.data.href, this.data) : Promise.resolve();
    }

    getElement() {
        try {
            return (
                eotwJSXFactory('div', {class: "js-item admin-gallery__item-wrap"}, [
                    eotwJSXFactory('div', {class: "admin-gallery__item " + this.getElementClasses()}, [
                        eotwJSXFactory('div', {class: "admin-gallery__item__preview", style: "background: url(" + this.getImageUrl() + ") center / cover"}),
                        eotwJSXFactory('img', {src: this.getImageUrl("1"/* Original */)}),
                        eotwJSXFactory('div', {class: "admin-gallery__item__buttons"}, [
                            eotwJSXFactory('button', {class: "admin-gallery__Hbtn admin-gallery__Hbtn--edit js-edit"}, [
                                eotwJSXFactory('span', {class: "admin-gallery__Hbtn__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "gallery/icons.svg#edit-icon'></use></svg>"),
                                "Edit"
                            ]),
                            eotwJSXFactory('button', {class: "admin-gallery__Hbtn admin-gallery__Hbtn--remove js-remove"}, [
                                eotwJSXFactory('span', {class: "admin-gallery__Hbtn__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "base/icons.svg#close'></use></svg>")
                            ])
                        ])
                    ])
                ])
            ).data("item", this);
        } catch (e) {
            console.log(e);
            return eotwJSXFactory('div', {class: "admin-gallery__item admin-gallery__item--error"})
        }
    }

    getModal() {
        throw new Error('Must override getModal');
    }

    /**
     * @return string
     */
    getImageUrl(size = '2' /* Thumbnail */) {
        throw Error('Must override getImageUrl');
    }
}

export default GalleryItem;
